import React, { useRef } from 'react';
import { AgGridReact } from 'ag-grid-react';
import { ColDef, AllCommunityModule, ICellRendererParams } from 'ag-grid-community';
import { ModuleRegistry, themeBalham } from 'ag-grid-community';
import { Permission } from '../../../utils/types/Permission';

ModuleRegistry.registerModules([AllCommunityModule]);

const InputCellRenderer = (props: ICellRendererParams<Permission>) => {
    const { value, data, colDef } = props;
    const handlePermissionUpdated = colDef?.cellRendererParams?.handlePermissionUpdated;
    const field = colDef?.field;

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const updatedPermission = { ...data, [field ?? '']: event.target.checked };

        if (handlePermissionUpdated) {
            handlePermissionUpdated(updatedPermission);
        }
    };

    return <input type="checkbox" checked={value ?? false} onChange={handleChange} />;
};

interface PermissionGridProps {
    permissions: Permission[];
    handlePermissionUpdated?: (permission: Permission) => void;
}

const PermissionGrid: React.FC<PermissionGridProps> = ({ permissions, handlePermissionUpdated }) => {
    const gridRef = useRef<AgGridReact>(null);

    const columnDefs: ColDef<Permission>[] = [
        { field: 'nomRessource', headerName: 'Ressource', sortable: true, filter: true, valueGetter: (params: any) => params.data.descriptionRessource || params.data.nomRessource },

        { field: 'typeRessource', headerName: 'Type', sortable: true, filter: true },

        {
            headerName: 'Création',
            field: 'creation',
            cellRenderer: InputCellRenderer,
            cellRendererParams: {
                handlePermissionUpdated: handlePermissionUpdated,
            },
            cellStyle: { textAlign: 'center' },
            wrapText: true,
            autoHeight: true,
        },

        {
            headerName: 'Lecture',
            field: 'lecture',
            cellRenderer: InputCellRenderer,
            cellRendererParams: {
                handlePermissionUpdated: handlePermissionUpdated,
            },
            cellStyle: { textAlign: 'center' },
            wrapText: true,
            autoHeight: true,
        },

        {
            headerName: 'Modification',
            field: 'modification',
            cellRenderer: InputCellRenderer,
            cellRendererParams: {
                handlePermissionUpdated: handlePermissionUpdated,
            },
            cellStyle: { textAlign: 'center' },
            wrapText: true,
            autoHeight: true,
        },

        {
            headerName: 'Suppression',
            field: 'suppression',
            cellRenderer: InputCellRenderer,
            cellRendererParams: {
                handlePermissionUpdated: handlePermissionUpdated,
            },
            cellStyle: { textAlign: 'center' },
            wrapText: true,
            autoHeight: true,
        },
    ];

    // ---

    const myTheme = themeBalham.withParams({
        columnBorder: { style: 'dashed', width: '1px' },
    });

    const onCellValueChanged = (params: any) => {
        const updatedPermission = { ...params.data };
        if (handlePermissionUpdated) {
            handlePermissionUpdated(updatedPermission);
        }
    };

    // ---

    return (
        <div className="" style={{ height: 500, width: '100%' }}>
            <AgGridReact
                ref={gridRef}
                theme={myTheme}
                getRowId={(params) => params.data.idRessource.toString()}
                rowData={permissions}
                columnDefs={columnDefs}
                domLayout="normal"
                defaultColDef={{
                    resizable: true,
                    minWidth: 100,
                    flex: 1,
                }}
                suppressClickEdit={true}
                suppressExcelExport={true}
                enableCellTextSelection={true}
                ensureDomOrder={true}
                animateRows={true}
                onCellValueChanged={onCellValueChanged}
                overlayNoRowsTemplate="<span style='padding: 10px;'>Aucune donnée ...</span>"
            />
        </div>
    );
};

export default PermissionGrid;
